export default "__VITE_ASSET__CcPCq4Tr__"